<div class="w-full flex flex-column gap-4" [ngClass]="{'overflow-scroll': scrollable}">
  <p-table #dt
    [value]="data"
    [rows]="pageParams.rows"
    [totalRecords]="pageParams.totalRecords"
    styleClass="p-datatable-sm custom-portfolio-table"
    [tableStyle]="{ 'min-width': '65rem' }"
    [rowHover]="true"
    [scrollable]="scrollable"
    [sortField]="defaultSortField"
    [sortOrder]="defaultSortOrder"
    [loading]="loading"
    responsiveLayout="stack">

    <ng-template pTemplate="header">
      <tr>
        @for (header of headers; track header) {
          <th
            [hidden]="header.hidden"
            [ngClass]="{
              'text-left pl-4': alignOf(header) === 'left',
              'text-right pr-4': alignOf(header) === 'right',
              'text-center': alignOf(header) === 'center',
              'dt-sortable': isSortable(header)
            }"
            class="white-space-nowrap p-4 border-none"
            (click)="onSort(header)">
            <div class="flex flex-row align-items-center gap-2"
               [ngClass]="{
                 'justify-content-start': alignOf(header) === 'left',
                 'justify-content-end': alignOf(header) === 'right',
                 'justify-content-center': alignOf(header) === 'center'
               }">
              <span>{{ header.column }}</span>
              @if (isSortable(header)) {
                <i class="pi dt-sort-icon"
                   [ngClass]="sortField === header.key ? (sortOrder === 1 ? 'pi-sort-amount-up-alt dt-sort-icon--active' : 'pi-sort-amount-down dt-sort-icon--active') : 'pi-sort-alt'"></i>
              }
            </div>
          </th>
        }
        @if (actions && actions.length > 0) {
          <th class="text-center font-bold p-4 border-none">Actions</th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr (click)="onRowClick(item)" [class.cursor-pointer]="rowClick.observed">
        @for (header of headers; track header) {
          <td
            [hidden]="header.hidden"
            [ngClass]="{
              'text-left pl-4': alignOf(header) === 'left',
              'text-right pr-4': alignOf(header) === 'right',
              'text-center': alignOf(header) === 'center'
            }"
            class="border-none py-3 px-4">
            <div class="flex w-full flex-column"
               [ngClass]="{
                 'align-items-start': alignOf(header) === 'left',
                 'align-items-end': alignOf(header) === 'right',
                 'align-items-center': alignOf(header) === 'center'
               }">
              @switch (header.type) {
                @case ('status') {
                  <p-tag [value]="getNestedValue(item, header.key)"
                    [severity]="getTagSeverity(getNestedValue(item, header.key))"
                    [icon]="getStatusIcon(getNestedValue(item, header.key))"
                    styleClass="status-tag">
                  </p-tag>
                }
                @case ('state') {
                  <p-tag [value]="getNestedValue(item, header.key)"
                    [severity]="getTagSeverity(getNestedValue(item, header.key))"
                    [icon]="getStatusIcon(getNestedValue(item, header.key))"
                    styleClass="status-tag">
                  </p-tag>
                }
                @case ('country') {
                  <span class="flex align-items-center gap-3">
                    <img [src]="'https://purecatamphetamine.github.io/country-flag-icons/3x2/' + getCountryCode(getNestedValue(item, header.key)) + '.svg'"
                      class="border-round-sm shadow-1"
                      style="width: 28px; height: 18px; object-fit: cover;" />
                    <span class="font-medium text-900">{{ getNestedValue(item, header.key) }}</span>
                  </span>
                }
                @case ('currency') {
                  @if (header.signKey) {
                    <span class="font-bold text-sm dt-amount" [ngClass]="isDebit(item, header) ? 'text-red-600' : 'text-green-600'">
                      {{ isDebit(item, header) ? '−' : '+' }}{{ getNestedValue(item, header.key) | currency : (header.currencyKey ? getNestedValue(item, header.currencyKey) : 'XOF') : 'symbol' : '1.0-0' : 'fr-FR' }}
                    </span>
                  } @else {
                    <span class="font-bold text-900 text-sm dt-amount">
                      {{ getNestedValue(item, header.key) | currency : (header.currencyKey ? getNestedValue(item, header.currencyKey) : 'XOF') : 'symbol' : '1.0-0' : 'fr-FR' }}
                    </span>
                  }
                }
                @case ('date') {
                  <span class="text-700 text-sm">
                    {{ getNestedValue(item, header.key) | date:'dd/MM/yyyy' }}
                  </span>
                }
                @case ('number') {
                  <span class="font-medium text-sm text-900 dt-amount">
                    {{ getNestedValue(item, header.key) | number:'1.2-2':'fr' }}
                  </span>
                }
                @case ('percent') {
                  <span class="font-semibold text-sm"
                    [ngClass]="header.colored !== false ? (getNestedValue(item, header.key) >= 0 ? 'text-green-600' : 'text-red-600') : 'text-blue-600'">
                    {{ getNestedValue(item, header.key) | number:'1.2-2':'fr' }}%
                  </span>
                }
                @case ('boolean') {
                  <i class="pi" [ngClass]="{'pi-check-circle text-green-500': getNestedValue(item, header.key), 'pi-times-circle text-red-500': !getNestedValue(item, header.key)}"></i>
                }
                @default {
                  <span class="text-700 font-medium text-sm">{{ getNestedValue(item, header.key) }}</span>
                }
              }
              @if (header.subKey && getNestedValue(item, header.subKey)) {
                <span class="dt-sub">{{ getNestedValue(item, header.subKey) }}</span>
              }
            </div>
          </td>
        }

        @if (actions && actions.length > 0) {
          <td>
            <div class="flex justify-content-center">
              <button pButton
                type="button"
                icon="pi pi-ellipsis-v"
                class="p-button-text p-button-rounded action-btn-hover"
                [disabled]="getActionsForRow(item).length === 0"
                (click)="$event.stopPropagation(); emit(item, $event, menu)">
              </button>
            </div>
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="headers.length + (actions.length > 0 ? 1 : 0)" class="text-center p-5 text-500">
          <ng-content></ng-content>
        </td>
      </tr>
    </ng-template>
  </p-table>

  @if (pageParams && pageParams.rows > 0) {
    <p-paginator
      [first]="pageParams.first"
      [rows]="pageParams.rows"
      [totalRecords]="pageParams.totalRecords"
      [rowsPerPageOptions]="pageParams.rowPerPageOptions"
      (onPageChange)="paginate.emit($event)"
      styleClass="custom-paginator border-top-1 border-gray-100 mt-0"
      [dropdownAppendTo]="'body'">
    </p-paginator>
  }
</div>

<p-menu #menu [popup]="true" [appendTo]="'body'" styleClass="dt-action-menu"></p-menu>
